import React from "react"
import peopleData from "../data/people.json"
import Image from "../components/image"
import Slider from "../components/slider"
import { slugify } from "../helpers/strings"

export default function PeopleGrid({ id, className }) {
  const data = peopleData.find(obj => {
    return obj.id === id
  })
  return (
    <section className={`people-grid ${className}`}>
      <div className="container container--padding-top-none util__tablet-up">
        <ul className="people-grid__grid">
          {data.people.map((person, index) => (
            <li key={index}>
              <figure>
                <Image path={person.imagePath} alt={person.name} />
              </figure>
              <figcaption>{person.title && <span className="title--micro title--light">{person.title}</span>}{person.name}</figcaption>
            </li>
          ))}
        </ul>
      </div>
      <div className="container container--full-width container--padding-none util__tablet-down">
        <Slider id={slugify(id)} slides={data.people} />
      </div>
    </section>
  )
}
